import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function TestimonialsHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} justifyContent="center" sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={3} sx={{ textWrap: "balance" }}>
                        Curățenie profesională pentru galerii comerciale și showroom-uri
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Oferim servicii de curățenie profesională pentru spații de prezentare unde
                        imaginea și experiența vizitatorilor sunt esențiale: galerii comerciale,
                        showroom-uri, zone de expoziție și alte spații similare.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Asigurăm întreținerea zilnică sau periodică a spațiilor cu trafic intens,
                        folosind proceduri adaptate suprafețelor sensibile și programului de
                        funcționare.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default TestimonialsHome;
